<script setup lang="ts">
import {
    NotificationSequenceable,
    NotificationSequenceDetails,
} from "@/notification-sequences/interfaces/NotificationSequence";
import NotificationSequencePreview
    from "@/notification-sequences/components/notification-sequence-preview/NotificationSequencePreview.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {NotificationTemplate} from "@/notification-template/interfaces";

defineProps<{
    tag: NotificationSequenceable | null;
    sequences: NotificationSequenceDetails[];
}>();

defineEmits<{
    (e: 'templateSelected', template: NotificationTemplate | undefined);
}>();
</script>

<template>
  <div class="flex flex-col gap-4">
    <div v-if="tag" class="flex flex-wrap items-center gap-2">
      <div class="shadow-md rounded-md shadow-muted-foreground overflow-hidden">
        <img v-if="tag.logo" :src="tag.logo" class="w-12 object-contain">
      </div>
      <h2 class="text-lg font-semibold">
        {{ tag.name }} ({{ sequences.length }} séquence{{ sequences.length > 1 ? 's' : '' }})
      </h2>
    </div>

    <hr v-else>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <NotificationSequencePreview
        v-for="sequence in sequences"
        :key="sequence.id"
        v-slot="{ selectedTemplate }"
        :sequence="sequence"
        class="mx-auto rounded-lg p-4"
      >
        <BaseButton primary density="comfortable" @click="$emit('templateSelected', selectedTemplate)">
          Recevoir ce SMS
        </BaseButton>
      </NotificationSequencePreview>
    </div>
  </div>
</template>
